'use client';

import type { ToastProps } from '@/components/base/toast/toast';
import { v4 as uuid } from 'uuid';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface Store {
  toasts: ToastProps[];
  addToast: (toast: Omit<ToastProps, 'id'>) => void;
  removeToast: (id: string) => void;
}

export const useToastsStore = create<Store>()((set) => ({
  toasts: [],
  addToast: (toast: Omit<ToastProps, 'id'>) =>
    set((state) => ({ toasts: [...state.toasts, { ...toast, id: uuid() }] })),
  removeToast: (toastId: string) =>
    set((state) => ({
      toasts: state.toasts.filter((toast) => toastId !== toast.id),
    })),
}));

export const useAddToast = () => useToastsStore(({ addToast }) => addToast);
